/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_1p46e_157 {
  display: flex;
}

._justify-content-space-between_1p46e_161 {
  justify-content: space-between;
}

._tabular-nums_1p46e_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_1p46e_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._Editor_1p46e_209 {
  display: flex;
  flex-direction: column;
  min-width: 25rem;
  color: #1a1818;
  transition: all 0.15s cubic-bezier(0.4, 0, 1, 1);
  will-change: all;
  height: 100%;
  border-top: 0.0625rem solid #dadcde;
}
._Editor_1p46e_209 li::before {
  display: none !important;
}
._Editor_1p46e_209 h1 {
  font-size: 2em;
  font-weight: bold;
  margin: 0.67em 0;
  line-height: 1.2;
}
._Editor_1p46e_209 h2 {
  font-size: 1.5em;
  font-weight: bold;
  margin: 0.83em 0;
  line-height: 1.2;
}
._Editor_1p46e_209 h3 {
  font-size: 1.17em;
  font-weight: bold;
  margin: 1em 0;
  line-height: 1.2;
}
._Editor_1p46e_209 h4 {
  font-size: 1em;
  font-weight: bold;
  margin: 1.33em 0;
  line-height: 1.2;
}
._Editor_1p46e_209 h5 {
  font-size: 0.83em;
  font-weight: bold;
  margin: 1.67em 0;
  line-height: 1.2;
}
._Editor_1p46e_209 h6 {
  font-size: 0.67em;
  font-weight: bold;
  margin: 2.33em 0;
  line-height: 1.2;
}
._Editor_1p46e_209 ul {
  list-style-type: disc;
  margin: 1em 0;
  padding-left: 40px;
}
._Editor_1p46e_209 ol {
  list-style-type: decimal;
  margin: 1em 0;
  padding-left: 40px;
}
._Editor_1p46e_209 li {
  margin: 0.5em 0;
}
._Editor_1p46e_209 blockquote {
  margin: 1em 0;
  padding: 0.5em 1em;
  border-left: 4px solid #ccc;
  background-color: #f9f9f9;
  font-style: italic;
  color: #555;
}
._Editor_1p46e_209._disabled_1p46e_279 {
  color: #8f8d91;
}
._Editor_1p46e_209 ._editorContainer_1p46e_282 {
  height: 100%;
}
._Editor_1p46e_209 ._editor_1p46e_282 {
  display: grid;
  width: 100%;
  padding: 1rem 1.5rem 2rem 1.5rem;
  height: 100%;
  cursor: text;
  flex: 1;
  gap: 0.5rem;
  overflow: auto;
  grid-template-rows: 1fr auto;
}
._Editor_1p46e_209 ._signature_1p46e_296 {
  margin-top: 1rem;
}
._Editor_1p46e_209 ._attachments_1p46e_299 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  margin: 1rem 1.5rem 0.75rem;
}
._Editor_1p46e_209 ._attachments_1p46e_299 ._item_1p46e_306 {
  flex-shrink: 0;
}
._Editor_1p46e_209 ._attachmentSelector_1p46e_309 {
  margin-right: 0.5rem;
}
._Editor_1p46e_209 ._editorSpace_1p46e_312 {
  border-top: 0.0625rem solid #dadcde;
  justify-content: space-between;
  padding: 0.5rem;
  overflow-x: scroll;
}
._Editor_1p46e_209 ._trashButton_1p46e_318 {
  padding: 0.25rem 0.5rem;
}